import storeApis from "../../api/storeApi";
import "react-toastify/dist/ReactToastify.min.css";
import * as types from "../../constants/ConversationActionTypes";
import _ from "lodash";
import { toast } from "react-toastify";
import Toast from "../../components/assetLibComponents/shared/Toast";




export const setConversationUnauthorized = () => {
    return (dispatch) => {
        dispatch({ type: "UNAUTHORIZED_CONVERSATION", payload: null });
    };
};
// getConversation
export const fetchConversationList = (authToken, startDate,endDate,page,search,filter,sort,limit) => {
    return async (dispatch) => {
        dispatch({ type: "TOGGLE_LOADING", payload: true });
        try {
            const response = await storeApis.post(
              "conversation/conversation_list",
               {
                start_date: startDate,
                end_date: endDate,
                search: search,
                page: page,
                filter:filter,
                sort:sort,
                limit:limit,
               },
                {
                    headers: {
                        Accept: "application/json",
                        Authorization: `Bearer ${authToken}`,
                    },
                }
            );
            if (response.status === 200) {
                if (response.data.statusCode == "403") {
                    // if (response.data.message == "Invalid Credentials" || response.data.message == "Unauthenticated" || response.data.message == "Unauthorized") {
                        dispatch({
                            type: "UNAUTHORIZED_CONVERSATION",
                            payload: response.data.statusCode,
                        });
                    // } else {
                    //     Toast(response.data.message, "E");
                    // }
                    dispatch({ type: "TOGGLE_LOADING", payload: false });
                }else if(response.data.statusCode == "400"){
                      dispatch({ type: "TOGGLE_LOADING", payload: false });
                }
                 else {
                    await dispatch({
                      type: types.FETCH_CONVERSATION_DATA,
                      payload: null,
                    });
                    await dispatch({
                      type: types.FETCH_CONVERSATION_LIST,
                      payload: null,
                    });
                    dispatch({
                      type: types.FETCH_CONVERSATION_DATA,
                      payload: response?.data,
                    });
                    dispatch({
                      type: types.FETCH_CONVERSATION_LIST,
                      payload: response?.data?.details,
                    });
                    // await dispatch(fetchLeadsList(authToken));
                    dispatch({ type: "TOGGLE_LOADING", payload: false });
                }
            }
        } catch (err) {
            console.log(err, "E");
            dispatch({ type: "TOGGLE_LOADING", payload: false });
            dispatch({ type: "UNAUTHORIZED_CONVERSATION", payload: err.response.status });
        }
    };
  };
export const fetchMessageList = (authToken, id) => {
    return async (dispatch) => {
        dispatch({ type: "TOGGLE_LOADING", payload: true });
        try {
            const response = await storeApis.post(
              "conversation/conversation_details",
               {
                prospect_token: id,       
               },
                {
                    headers: {
                        Accept: "application/json",
                        Authorization: `Bearer ${authToken}`,
                    },
                }
            );
            if (response.status === 200) {
                if (response.data.statusCode == "403") {
                    // if (response.data.message == "Invalid Credentials" || response.data.message == "Unauthenticated" || response.data.message == "Unauthorized") {
                        dispatch({
                            type: "UNAUTHORIZED_CONVERSATION",
                            payload: response.data.statusCode,
                        });
                    // } else {
                    //     Toast(response.data.message, "E");
                    // }
                    dispatch({ type: "TOGGLE_LOADING", payload: false });
                }else if(response.data.statusCode == "400"){
                        dispatch({ type: "TOGGLE_LOADING", payload: false });
                }
                 else {
                    // Toast(response.data.message, "S");
                    await dispatch({
                      type: types.FETCH_MESSAGE_LIST,
                      payload: null,
                    });
                    dispatch({
                      type: types.FETCH_MESSAGE_LIST,
                      payload: response?.data,
                    });
                    // await dispatch(fetchLeadsList(authToken));
                    dispatch({ type: "TOGGLE_LOADING", payload: false });
                }
            }
        } catch (err) {
            console.log(err, "E");
            dispatch({ type: "TOGGLE_LOADING", payload: false });
            dispatch({ type: "UNAUTHORIZED_CONVERSATION", payload: err.response.status });
        }
    };
};

export const multipleDeleteConversation = (authToken, data) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: true });
    try {
      const response = await storeApis.post(
        "conversation/delete_summary",
        {
            session_id: data
        },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_CHAT_AI",
            payload: response.data.statusCode,
          });
          // Toast(response.data.message, "E");
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else {
              dispatch(fetchConversationList(authToken,null,null,1,"","","",""));

          // Toast(response.data.message, "S");
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        }
      }
    } catch (err) {
      console.log(err, "E");
      dispatch({ type: "TOGGLE_LOADING", payload: false });
      dispatch({
        type: "UNAUTHORIZED_CHAT_AI",
        payload: err.response.status,
      });
    }
  };
};